export type LocalStorageKeys =
  | "authToken"
  | "refreshToken"
  | "wooSession"
  | "wishlist"
  | "welcomeModal"
  | "user"
  | "viewerFetchedAt";

export interface LocalStorageValues {
  authToken: string;
  refreshToken: string;
  wooSession: string;
  wishlist?: Array<number>;
  user?: string;
}

export const parseLocalStorageValues = () => {
  try {
    const localItems = localStorage.getItem("PROFITISHOP_USER");

    if (localItems === null) {
      return {};
    }

    return JSON.parse(localItems);
  } catch (e) {
    return {};
  }
};

export const getLocalValues = () => {
  const localValues = parseLocalStorageValues();

  return {
    authToken: localValues?.authToken,
    refreshToken: localValues?.refreshToken,
    wooSession: localValues?.wooSession,
    wishlist: localValues?.wishlist || [],
    welcomeModal: localValues?.welcomeModal || "",
    user: localValues?.user || "",
    viewerFetchedAt: localValues?.viewerFetchedAt || "",
  };
};

export const setLocalValue = (
  key: LocalStorageKeys,
  value: string | number[]
) => {
  const localValues = parseLocalStorageValues();

  const newValue = {
    ...localValues,
    [key]: value,
  };

  localStorage.setItem("PROFITISHOP_USER", JSON.stringify(newValue));
};

export const deleteLocalValue = (key: LocalStorageKeys) => {
  const localValues = parseLocalStorageValues();

  if (localValues[key]) {
    delete localValues[key];
  }

  if (localValues) {
    localStorage.setItem("PROFITISHOP_USER", JSON.stringify(localValues));
  } else {
    localStorage.removeItem("PROFITISHOP_USER");
  }
};

export const getCachedUser = () => {
  const raw = getLocalValues().user;
  if (!raw) {
    return undefined;
  }

  try {
    return typeof raw === "string" ? JSON.parse(raw) : raw;
  } catch (e) {
    return undefined;
  }
};

export const setCachedUser = (user: unknown) => {
  if (!user) {
    deleteLocalValue("user");
    return;
  }

  setLocalValue("user", JSON.stringify(user));
};
